<div class="candidate-login-container" appBlockCopyPaste *ngIf="!isMobile">
  <div class="login-wrapper">
    <!-- Left Section - Form -->
    <div class="form-section">
      <div class="branding-section">
        <div class="evaltrix-logo">Evaltrix</div>
        <div class="invitation-text">
          <strong>{{companyName}}</strong> invited you to take an assessment
        </div>
        <div class="powered-by">
          Powered by <span class="brand-name">Evaltrix</span>
        </div>
      </div>

      <div class="form-container">
        <form class="login-form" [formGroup]="candidateLoginForm">
          <!-- Name Field (for new users) -->
          <div class="form-group" *ngIf="!isForgotPasswordClicked && !isExistingUser">
            <label class="form-label">Full Name</label>
            <mat-form-field class="custom-field" appearance="outline">
              <input matInput placeholder="Enter your name" formControlName="name" required>
              <mat-icon matSuffix class="field-icon">person</mat-icon>
            </mat-form-field>
          </div>

          <!-- Email Field -->
          <!-- Email Field (ALWAYS REQUIRED) -->
          <div class="form-group">
            <label class="form-label">Email Address *</label>
            <mat-form-field class="custom-field" appearance="outline">
              <input matInput type="email" placeholder="Enter your email" formControlName="email"
                [readonly]="hasEmail && isExistingUser" required>
              <mat-icon matSuffix class="field-icon">email</mat-icon>
              <mat-error *ngIf="candidateLoginForm.get('email').hasError('required')">
                Email is required
              </mat-error>
              <mat-error *ngIf="candidateLoginForm.get('email').hasError('email')">
                Please enter a valid email address
              </mat-error>
            </mat-form-field>
            <mat-hint *ngIf="!isExistingUser && !isForgotPasswordClicked"
              style="font-size: 11px; margin-top: -5px; display: block;">
              Required for password recovery and future communications
            </mat-hint>
          </div>

          <!-- Phone Field (Optional/Display only) -->
          <div class="form-group" *ngIf="hasPhone && !isForgotPasswordClicked">
            <label class="form-label">Phone Number</label>
            <mat-form-field class="custom-field" appearance="outline">
              <input matInput type="tel" placeholder="Enter your phone number" formControlName="phone"
                [readonly]="true">
              <mat-icon matSuffix class="field-icon">phone</mat-icon>
            </mat-form-field>
          </div>

          <!-- Password Field -->
          <div class="form-group" *ngIf="!isForgotPasswordClicked">
            <label class="form-label password-label">
              <span>{{ isExistingUser ? 'Password' : 'Set Password'}}</span>
              <mat-icon class="info-icon" matTooltip="{{passwordConditions}}" matTooltipClass="custom-tooltip"
                matTooltipPosition="above">
                info_outline
              </mat-icon>
            </label>
            <mat-form-field class="custom-field" appearance="outline">
              <input [type]="showPassword ? 'text' : 'password'" matInput placeholder="Enter password"
                formControlName="password" required>
              <mat-icon matSuffix class="field-icon clickable"
                (click)="$event.stopPropagation(); showPassword = !showPassword">
                {{showPassword ? 'visibility' : 'visibility_off'}}
              </mat-icon>
            </mat-form-field>
            <div class="password-errors"
              *ngIf="candidateLoginForm.get('password').touched && candidateLoginForm.get('password').errors">
              <ul class="error-list">
                <li *ngIf="candidateLoginForm.get('password').errors.minlength">
                  Password must be at least 6 characters long
                </li>
              </ul>
            </div>
          </div>

          <!-- Terms and Links -->
          <div class="footer-links">
            <div class="terms-text">
              By continuing, you agree to <span class="link-text" (click)="terms()">our terms of use</span>
            </div>
            <div class="action-link" *ngIf="isForgotPasswordClicked">
              <span class="link-text" (click)="backToLogin()">← Back to login</span>
            </div>
            <div class="action-link" *ngIf="!isForgotPasswordClicked && isExistingUser">
              <span class="link-text" (click)="forgotPassword()">Forgot password?</span>
            </div>
          </div>

          <!-- Submit Button -->
          <button mat-raised-button class="submit-button" [disabled]="!candidateLoginForm.valid"
            *ngIf="!isForgotPasswordClicked" (click)="signInOrRegister()">
            <span>View Assessment</span>
            <mat-icon>arrow_forward</mat-icon>
          </button>

          <button mat-raised-button class="submit-button" *ngIf="isForgotPasswordClicked" (click)="requestResetLink()">
            <span>Request Reset Link</span>
            <mat-icon>send</mat-icon>
          </button>
        </form>
      </div>
    </div>

    <!-- Right Section - Illustration -->
    <div class="illustration-section">
      <div class="illustration-content">
        <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
          <!-- Background circles -->
          <circle cx="250" cy="220" r="200" fill="#E8F4FF" opacity="0.4" />
          <circle cx="250" cy="220" r="150" fill="#DBEAFE" opacity="0.3" />

          <!-- Computer/Screen -->
          <rect x="150" y="150" width="200" height="140" rx="8" fill="white" stroke="#3F51B5" stroke-width="3" />
          <rect x="160" y="160" width="180" height="100" rx="4" fill="#F0F4FF" />

          <!-- Code lines on screen -->
          <line x1="170" y1="175" x2="250" y2="175" stroke="#3F51B5" stroke-width="3" stroke-linecap="round" />
          <line x1="170" y1="190" x2="280" y2="190" stroke="#667eea" stroke-width="3" stroke-linecap="round" />
          <line x1="170" y1="205" x2="230" y2="205" stroke="#3F51B5" stroke-width="3" stroke-linecap="round" />
          <line x1="170" y1="220" x2="260" y2="220" stroke="#667eea" stroke-width="3" stroke-linecap="round" />
          <line x1="170" y1="235" x2="240" y2="235" stroke="#3F51B5" stroke-width="3" stroke-linecap="round" />

          <!-- Computer stand -->
          <rect x="230" y="290" width="40" height="30" fill="#3F51B5" />
          <rect x="200" y="320" width="100" height="8" rx="4" fill="#3F51B5" />

          <!-- Person -->
          <circle cx="250" cy="380" r="30" fill="#FFB84D" />
          <path d="M 220 415 Q 220 395 250 395 Q 280 395 280 415 L 280 440 L 220 440 Z" fill="#4A5568" />

          <!-- Checkmark badge -->
          <circle cx="340" cy="180" r="30" fill="#10B981" />
          <path d="M 325 180 L 333 188 L 355 166" stroke="white" stroke-width="5" fill="none" stroke-linecap="round"
            stroke-linejoin="round" />

          <!-- Decorative elements -->
          <circle cx="380" cy="280" r="12" fill="#FFB84D" opacity="0.6" />
          <circle cx="120" cy="200" r="10" fill="#10B981" opacity="0.5" />
          <circle cx="140" cy="320" r="8" fill="#3F51B5" opacity="0.4" />
          <circle cx="360" cy="380" r="10" fill="#667eea" opacity="0.5" />

          <!-- Stars/Sparkles -->
          <path
            d="M 380 120 L 383 128 L 391 125 L 383 132 L 386 140 L 380 133 L 374 140 L 377 132 L 369 125 L 377 128 Z"
            fill="#FFB84D" opacity="0.8" />
          <path
            d="M 140 140 L 142 146 L 148 144 L 142 150 L 144 156 L 140 150 L 136 156 L 138 150 L 132 144 L 138 146 Z"
            fill="#10B981" opacity="0.7" />
        </svg>
        <div class="illustration-text">
          <h2>Ready to Showcase Your Skills?</h2>
          <p>Complete your assessment and demonstrate your expertise to potential employers.</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Mobile Not Supported -->
<div *ngIf="isMobile">
  <div class="no-mobile-support">
    <img src="../../assets/mobile-not-support.png" alt="Mobile not supported">
    <div>Sorry! This assessment can't be taken on mobile devices. Please open this link on your desktop or laptop.</div>
  </div>
</div>